import request from '@/axios';

/** 从业务字典获取协议名称的接口 */
export const getProtocolNameFromDict = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "protocol_compliance_name"
    }
  });
}

/** 从业务字典中获取协议地址的接口 */
export const getProtocolUrlFromDict = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "protocol_compliance_url"
    }
  });
}

/** 分页的接口 */
export const getProtocolList = (params) => {
  return request({
    url: "/lebo-rabbit/agreement-template/page",
    method: "get",
    params,
  });
}

/** 新增协议模板 */
export const addProtocol = (data) => {
  return request({
    url: "/lebo-rabbit/agreement-template",
    method: "post",
    data,
  });
}

/** 修改协议模板 */
export const updateProtocol = (data) => {
  return request({
    url: "/lebo-rabbit/agreement-template",
    method: "put",
    data,
  });
}

/** 删除协议模板 */
export const deleteProtocol = (id) => {
  return request({
    url: `/lebo-rabbit/agreement-template`,
    method: "delete",
    params: {
      ids: id
    }
  });
}

/** 发布协议模板 */
export const publishProtocol = (id) => {
  return request({
    url: `/lebo-rabbit/agreement-template/publish/${id}`,
    method: "put",
  });
}